// extracted by mini-css-extract-plugin
module.exports = {"btn":"ProfileMenu_btn__25-xp","link":"ProfileMenu_link__3X1kk","menu":"ProfileMenu_menu__1bfoO"};